import {
	Scrollbar as RadixScrollbar,
	type ScrollAreaScrollbarProps,
	ScrollAreaThumb
} from '@radix-ui/react-scroll-area'
import type { FC } from 'react'

export const Scrollbar: FC<ScrollAreaScrollbarProps> = (props) => {
	return (
		<RadixScrollbar
			className='flex touch-none select-none bg-transparent data-[orientation=horizontal]:h-1.5 data-[orientation=vertical]:w-1.5 data-[orientation=horizontal]:flex-col'
			{...props}
		>
			<ScrollAreaThumb className="relative flex-1 rounded-[3px] bg-neutral-300 transition-colors duration-200 ease-in-out before:absolute before:top-1/2 before:left-1/2 before:h-full before:w-full before:-translate-x-1/2 before:-translate-y-1/2 before:content-[''] hover:bg-neutral-400" />
		</RadixScrollbar>
	)
}

Scrollbar.displayName = 'Scrollbar'
